import { InputDeviceType, ControllerHand, degToRad } from "flavr-common";
import { Vector3, Quaternion, Euler } from "flavr-math";
import { SELECTION_STRATEGY } from "../../../messages/selection";
const LEFT_VIVE_INDEX_CONTROLLER_MESH_FILE = "meshes/vive/left_index_controller";
const RIGHT_VIVE_INDEX_CONTROLLER_MESH_FILE = "meshes/vive/right_index_controller";
function getViveIndexControllerMeshInfo(rightHand) {
    const sign = rightHand ? -1 : +1;
    return {
        name: rightHand ? "index_right" : "index_left",
        type: InputDeviceType.ValveIndexController,
        file: rightHand ? RIGHT_VIVE_INDEX_CONTROLLER_MESH_FILE : LEFT_VIVE_INDEX_CONTROLLER_MESH_FILE,
        side: rightHand ? ControllerHand.RightHand : ControllerHand.LeftHand,
        buttons: [
            {
                index: 0,
                annotation: {
                    anchorPoint: [sign * 0.008, -0.023, 0.047],
                    position: [sign * 0.06, -0.04, 0.02]
                },
                subMeshNames: {
                    pressed: "button_trigger_1",
                    released: "button_trigger_0"
                }
            },
            {
                index: 1,
                annotation: {
                    anchorPoint: [sign * 0.01442, 0.004268, 0.119386],
                    position: [sign * 0.045096, 0.005487, 0.121873]
                },
                subMeshNames: {
                    pressed: "button_grip_1",
                    released: "button_grip_0"
                }
            },
            {
                index: 4,
                annotation: {
                    anchorPoint: [sign * 0.024477, 0.019199, 0.056246],
                    position: [sign * 0.036, 0.019199, 0.056246]
                },
                subMeshNames: {
                    pressed: "button_a_1",
                    released: "button_a_0"
                }
            },
            {
                index: 5,
                annotation: {
                    anchorPoint: [sign * 0.026788, 0.014321, 0.044409],
                    position: [sign * 0.035, 0.014321, 0.035]
                },
                subMeshNames: {
                    pressed: "button_b_1",
                    released: "button_b_0"
                }
            },
            {
                index: 2,
                annotation: {
                    anchorPoint: [sign * 0.00201, 0.010852, 0.03536],
                    position: [sign * -0.013684, 0.020888, 0.01061]
                },
                subMeshNames: {
                    pressed: "trackpad_1",
                    released: "trackpad_0"
                }
            }
        ],
        invertYAxis: -1,
        recordIndicator: {
            position: new Vector3(sign * 0.005873, 0.0133, 0.041178),
            orientation: new Quaternion().setFromEuler(new Euler(degToRad(-23.9434 - 90), degToRad(sign * 6.05217), degToRad(0), "XZY")),
            scale: new Vector3().setScalar(0.06)
        },
        makerRadar: {
            radius: 0.05,
            position: new Vector3(sign * 0.023339, 0.052412, -0.025381),
            markerScale: 0.04
        },
        gripSpace: {
            position: new Vector3(),
            orientation: new Quaternion(),
            scale: new Vector3(1, 1, 1)
        },
        selection: {
            strategy: SELECTION_STRATEGY.RAY_SELECT,
            params: {
                max_ray_length: 1000,
                ray_visible: true,
                ray_color: 0x06316d,
                ray_head_length: 0.05,
                ray_head_width: 0.01
            }
        }
    };
}
export const LEFT_VIVE_INDEX_CONTROLLER_MESH_INFO = getViveIndexControllerMeshInfo(false);
export const RIGHT_VIVE_INDEX_CONTROLLER_MESH_INFO = getViveIndexControllerMeshInfo(true);
